/**
 * Team Chat API Service
 * Segue o mesmo padrão de kbApi.js existente.
 */

const API_URL = process.env.REACT_APP_CRM_API_URL || 'http://localhost:5000/api/crm';

class TeamChatApi {

  // ── Canais ────────────────────────────────────

  static async getChannels(sellerId) {
    const res = await fetch(`${API_URL}/team/channels?seller_id=${sellerId}`);
    if (!res.ok) throw new Error('Erro ao buscar canais');
    return res.json();
  }

  static async createChannel(sellerId, name, description = '') {
    const res = await fetch(`${API_URL}/team/channels`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seller_id: sellerId, name, description }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || 'Erro ao criar canal');
    }
    return res.json();
  }

  static async getMembers(channelId) {
    const res = await fetch(`${API_URL}/team/channels/${channelId}/members`);
    if (!res.ok) throw new Error('Erro ao buscar membros');
    return res.json();
  }

  static async addMember(channelId, sellerId) {
    const res = await fetch(`${API_URL}/team/channels/${channelId}/members`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seller_id: sellerId }),
    });
    if (!res.ok) throw new Error('Erro ao adicionar membro');
    return res.json();
  }

  // ── Mensagens ─────────────────────────────────

  static async getMessages(channelId, status = null) {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    const res = await fetch(`${API_URL}/team/channels/${channelId}/messages?${params}`);
    if (!res.ok) throw new Error('Erro ao buscar mensagens');
    return res.json();
  }

  static async sendMessage(channelId, sellerId, text) {
    const res = await fetch(`${API_URL}/team/channels/${channelId}/messages`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seller_id: sellerId, text }),
    });
    if (!res.ok) throw new Error('Erro ao enviar mensagem');
    return res.json();
  }

  static async toggleStatus(messageId, sellerId) {
    const res = await fetch(`${API_URL}/team/messages/${messageId}/status`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seller_id: sellerId }),
    });
    if (!res.ok) throw new Error('Erro ao atualizar status');
    return res.json();
  }

  // ── Threads ───────────────────────────────────

  static async sendThread(messageId, sellerId, text) {
    const res = await fetch(`${API_URL}/team/messages/${messageId}/threads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seller_id: sellerId, text }),
    });
    if (!res.ok) throw new Error('Erro ao responder thread');
    return res.json();
  }

  // ── Processos ─────────────────────────────────

  static async createProcess(channelId, sellerId, type, contactName, contactId = null) {
    const res = await fetch(`${API_URL}/team/channels/${channelId}/processes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seller_id: sellerId, type, contact_name: contactName, contact_id: contactId }),
    });
    if (!res.ok) throw new Error('Erro ao criar processo');
    return res.json();
  }

  static async getProcess(processId) {
    const res = await fetch(`${API_URL}/team/processes/${processId}`);
    if (!res.ok) throw new Error('Erro ao buscar processo');
    return res.json();
  }

  static async updateProcessStep(processId, stepKey, data) {
    const res = await fetch(`${API_URL}/team/processes/${processId}/steps/${stepKey}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Erro ao atualizar etapa');
    return res.json();
  }
  static async uploadStepAttachment(processId, stepKey, sellerId, file) {
    const form = new FormData();
    form.append('file', file);
    form.append('seller_id', sellerId);
    const res = await fetch(`${API_URL}/team/processes/${processId}/steps/${stepKey}/upload`, {
      method: 'POST',
      body: form,
    });
    if (!res.ok) throw new Error('Erro ao fazer upload');
    return res.json();
  }

}

export default TeamChatApi;
